<template>
	<div>
		<div class="footer">
			<div class="footer-box" v-if="isMobile">
				<div class="footer-code">
					<div class="footer-item">
						<img class="footer-qrcode" src="@/assets/wxmpqrcode.png" alt="">
						<div class="">关注微信公众号</div>
					</div>
					<div class="footer-item">
						<img class="footer-qrcode" src="@/assets/wechatvideo.jpg" alt="">
						<div class="">关注GD粤新材料视频号</div>
					</div>
				</div>
				<div class="flex copyright justify-center">
					<div>地址：</div>
					<div>
						<div>广东省佛山市南海区里水镇中金路2号</div>
						<div>广东省新材料产业基地 A 座六层</div>
					</div>
				</div>
				<div class="copyright" style="text-align: center;margin-top: 2.3339vw;">
					<span>Copyright © 2020 广东省工业新材料协会 All Rights Reserved</span>&nbsp;
					<span>粤IC备：19162665号</span>
				</div>
			</div>
			<div class="footer-box" v-else>
				<div class="footer-top">
					<img class="footer-logo" src="@/assets/logo.png" alt="">
					<div>
						<div class="zh">广东省工业新材料协会</div>
						<div class="en">GUANGDONG INDUSTRIAL ADVANCED MATERIALS ASSOCIATION</div>
					</div>
				</div>
				<div class="footer-bottom">
					<div class="footer-content">
						<div class="footer-text">
							<div class="flex address-row">
								<div class="label">地址/Address：</div>
								<div class="content">
									<div>
										广东省佛山市南海区里水镇中金路2号 广东省新材料产业基地 A 座六层
									</div>
									<div>
										No.2 Zhongjin Road, Lishui Town, Nanhai District, Foshan City, Guangdong
										6th Floor, Block A, Guangdong Advanced Materials Industrial Base
									</div>
								</div>
							</div>
							<div class="flex info-row">
								<div class="label">电话/Tel：</div>
								<div class="content">0757-85689731</div>
							</div>
							<div class="flex info-row">
								<div class="label">传真/Fax：</div>
								<div class="content">0757-85689701</div>
							</div>
						</div>
						<div class="footer-text">
							<div class="flex info-row">
								<div class="label"><div>工作时间/</div>Office Hours：</div>
								<div class="content">
									周一至周五/Mon-Fri <br/>8:30 - 11:30，14:00 - 17:00<br />周六/Saturday  <br/>8:30 - 12:00，13:30 - 15:30
								</div>
							</div>
							<div class="flex info-row">
								<div class="label">邮箱/Email：</div>
								<div class="content">gdxclxh@163.com</div>
							</div>
							<div class="flex info-row">
								<div class="label">官网/Website：</div>
								<div class="content">http://www.advancedmaterials.org.cn/</div>
							</div>
						</div>
					</div>
					<div class="footer-code">
						<div class="footer-item">
							<img class="footer-qrcode" src="@/assets/wxmpqrcode.png" alt="">
							<div class="">关注微信公众号</div>
						</div>
						<div class="footer-item">
							<img class="footer-qrcode" src="@/assets/wechatvideo.jpg" alt="">
							<div class="">关注GD粤新材料视频号</div>
						</div>
					</div>
				</div>
				<div class="beian" @click="toBeianhao">粤IC备19162665号 <span class="pv" v-if="pv">总访问量：{{ pv }}次</span></div>
				
			</div>
		</div>
		<div class="block"></div>
	</div>
</template>
<script>
	export default {
		name: 'footer-nav',
		data() {
			return {
				isMobile: this.isMoBile(),
				pv: 0,  // 由接口 /api/front/index/pv 回显（百度统计 API 或自建统计）
			}
		},
		async created() {
			// 百度 API 有调用门槛，暂不请求 /pv/record；总访问量由 GET /pv 在自建统计时顺带累加
			await this.initPvValue();
		},
		methods: {
			toBeianhao() {
				window.open('https://beian.miit.gov.cn/')
			},
			async initPvValue() {
				const {
					data
				} = await this.$axios.api.pv();
				this.pv = data
			},
		}
	}
</script>
<style lang="scss" scoped>
	@media screen and (min-width: 1000px) {
		.footer {
			position: relative;
			min-width: 1280px;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #d81c20;
			color: #FFFFFF;
			box-sizing: border-box;

		}

		.navbg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 0;
		}

		.footer-box {
			padding: 20px 0 60px 0;
			width: 1280px;
			box-sizing: border-box;
			position: relative;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.footer-top {
			width: 100%;
			display: flex;
			align-items: center;
			font-weight: bold;
			font-size: 28px;
			
			.zh {
				letter-spacing: 10px;
			}
			.en {
				font-weight: lighter;
				font-size: 14px;
				padding-top: 5px;
			}
		}

		.footer-logo {
			width: 85px;
			height: 85px;
			margin-right: 20px;
		}


		.footer-bottom {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 10px;
		}

		.footer-content {
			flex: 1;
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
		}

		.footer-code {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.beian,
		.pv {
			font-size: 14px;
			position: absolute;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
			text-decoration: none;
			color: inherit;
			outline: none;
			cursor: pointer;
		}

		.pv {
			position: unset;
			bottom: 0px;
			text-align: center;
		}

		.footer-item {
			font-weight: 400;
			font-size: 14px;
			color: #FFFFFF;
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.footer-item+.footer-item {
			margin-left: 53px;
		}

		.footer-qrcode {
			width: 80px;
			height: 80px;
			background: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 7px;
		}

		.footer-text {
			font-weight: 400;
			font-size: 14px;
			color: #FFFFFF;
			line-height: 26px;

			.flex {
				display: flex;
				align-items: flex-start;
				margin: 0 25px 6px 0;

				&.address-row {
					.label {
						width: 105px;
						flex-shrink: 0;
						word-break: keep-all;
						overflow-wrap: break-word;
					}

					.content {
						flex-grow: 1;
					}
				}

				&.info-row {
					.label {
						width: 105px;
						flex-shrink: 0;
					}

					.content {
						flex-grow: 1;
					}
				}
			}
		}
	}

	@media screen and (max-width: 999px) {
		.footer {
			position: relative;
			padding: 4vw 2.666666vw;
			background-color: #d81c20;
			color: #FFFFFF;
			box-sizing: border-box;
		}

		.copyright {
			color: #f8dada;
			font-size: 3.2vw;
		}

		.footer-top {
			margin-bottom: 2.666666vw;
			width: 100%;
			display: flex;
			align-items: center;
			font-weight: bold;
			font-size: 4vw;
		}

		.footer-logo {
			width: 12vw;
			height: 12vw;
			margin-right: 5vw;
		}

		.footer-content {
			line-height: 5.33333vw;
			font-size: 3.2vw;
		}

		.footer-code {
			display: flex;
			justify-content: center;

			.footer-item {
				text-align: center;
				font-size: 3.2vw;
				margin-bottom: 2.666666vw;
				color: #f8dada;

				img {
					padding: 4px;
					background-color: #fff;
					width: 20vw;
					height: 20vw;
				}
			}

			.footer-item:nth-child(2) {
				margin-left: 5.333339vw;
			}

			.footer-text-weekends {
				display: inline-block;
			}
		}

		.beian,
		.pv {
			width: 100%;
			font-size: 3.2vw;
			text-align: center;
		}

		.pv {
			bottom: 0px;
		}
	}
</style>